<div class="container section__approval h-full" *ngIf="isRequestApproved">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-300">
      <article>
        <div class="mainInfo">
          <i class="mainIcon mainIcon--kredicash">
            <img src="assets/images/logos/kredicash-logo.png" alt="Kredicash">
          </i>
          <h1>¡Felicitaciones!</h1>
          <p>
            Tu Kredicash ha sido aprobado.
          </p>
        </div>

        <div class="backgroundArrow">
          <div class="arrowSvg">
            <svg width="55" height="39" viewBox="0 0 55 39" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.5">
                <path d="M29.4555 16.4348L18.4474 4.89504C16.9489 3.32418 14.4589 3.27616 12.8745 4.78756L1.23526 15.8906C-0.349133 17.402 -0.418519 19.8915 1.07997 21.4624L12.0881 33.0021C13.5866 34.573 16.0766 34.621 17.661 33.1096L29.3002 22.0066C30.8846 20.4952 30.954 18.0057 29.4555 16.4348ZM16.3354 31.72C15.5432 32.4757 14.2389 32.4505 13.4897 31.6651L2.48155 20.1253C1.73231 19.3399 1.76865 18.0359 2.56085 17.2802L14.2001 6.17717C14.9923 5.42146 16.2966 5.44662 17.0458 6.23205L28.054 17.7718C28.8032 18.5572 28.7669 19.8613 27.9747 20.617L16.3354 31.72Z" fill="#BCBCC2" />
                <path d="M31.98 36.529L18.2631 22.1496C16.4188 20.2163 16.447 17.0736 18.458 15.1553L32.9004 1.37823C34.8504 -0.481957 37.9942 -0.480633 39.8962 1.51315L53.5555 15.8321C55.3998 17.7655 55.3715 20.9082 53.3605 22.8265L38.9182 36.6035C36.9648 38.5823 33.8243 38.4624 31.98 36.529Z" fill="#BCBCC2" />
              </g>
              <path class="svgStroke--secondary" d="M35 16L27.5 22.8182L20 16" stroke="#000" stroke-width="3"
                stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <div class="simulationResumeBox__result" *ngIf="isApprovedEqual() || isApprovedLess() || isBetterProduct()">
          <div class="simulationResumeBox__summary">
            <div class="simulationResumeBox__summaryCont">
              <ul class="simulationResumeBox__summaryItems">
                <li class="simulationResumeBox__summaryItem highlight"><p><span class="title"><strong>Monto solicitado</strong></span><span class="value">{{request()?.quotes.prices.selected | currency  }}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Cuota quincenal</span><span class="value">{{ request()?.quotes.quota.selected| currency }}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Próximo pago</span><span class="value">{{ returnPaymentDate()  | date: 'dd/MM/yyyy' }}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Total a pagar</span><span class="value">{{ (request()?.quotes.quota.selected * request()?.quotes.quota.quantity) | currency }}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Total cuotas</span><span class="value">{{ request()?.quotes.quota.quantity }} cuotas quincenales</span></p></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="generalDescription mt-25" *ngIf="isBetterProduct()">
          <p class="mb-15">
            <strong>¡Tenemos una gran oportunidad para ti!</strong>
            <br>
            {{ 'Puedes acceder a un monto de crédito hasta' | termReplace }} <span class="highlight"><strong>{{ request()?.best_financeable_product.quotes.prices.suggested | currency }}</strong></span>.
          </p>
          <button pButton pRipple label="Cambiar mi cupo" class="p-button-secondary p-button-raised p-button-rounded n-background min-pad" (click)="showModal()"></button>
        </div>
      </article>

      <footer>
        <div class="footer__content">
          <button pButton pRipple label="Aceptar y continuar" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="approveRequest()"></button>
        </div>
      </footer>
    </div>
  </div>
</div>


<!-- MODAL SIMULADOR -->
<p-dialog [(visible)]="visibleModalChangeQuota" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Cambiar mi cupo</h2>
          <p>Modifica la información proporcionada para cambiar tu cupo.</p>
        </div>
        <div class="dialog__form">
          <div class="dialog__simulator">
            <app-sales-simulator-kredicash-embedded
              [mode]="'modal'"
              [initialProducts]="products()"
              [initialSalary]="request()?.simulation.salary || 600"
              [externalCategoryId]="requestService.categoryId"
              [requestId]="requestId"
              (modalSaveEvent)="onModalSave($event)" *ngIf="visibleModalChangeQuota">
            </app-sales-simulator-kredicash-embedded>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- MODAL APPROVED LESS -->
<p-dialog [(visible)]="visibleModalApprovedLess" [modal]="true" [draggable]="false" [resizable]="false" position="center">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <i>
            <img src="assets/images/logos/kredicash-logo.png" alt="Kredicash">
          </i>
          <h2>Te pedimos leer con atención la siguiente información</h2>
          <p>Hemos evaluado tu solicitud y en esta ocasión podemos ofrecerte un cupo menor al solicitado.</p>
          <p class="pt-20">Para ver tu cupo  Kredicash presiona el botón <strong>"Continuar"</strong>.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="visibleModalApprovedLess=false;"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
